<template>
  <!-- Header -->
  <div class="relative md:pt-24 pb-32 pt-12" style="background: rgb(5,150,105);
  background: linear-gradient(90deg, rgba(5,150,105,1) 35%, rgba(19,84,122,1) 100%);">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">

          <div class="w-full lg:w-6/12 xl:w-3/12 px-4 ">
            <router-link to="/general">
              <card-stats statSubtitle="All Students" :statTitle="student_arr.all_student" 
              statIconName="fa fa-address-card" statIconColor="bg-red-500" />
            </router-link>
          </div>

          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <router-link to="/subject">
              <card-stats statSubtitle="Subjects Present in Curriculum" :statTitle="subject_arr.sum_all" 
                statIconName="fas fa-folder-open" statIconColor="bg-orange-500" />
            </router-link>
          </div>
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <router-link to="/lecturer">
              <card-stats statSubtitle="All Staffs" :statTitle="teacher_arr.sum_all" 
                statIconName="fas fa-users" statIconColor="bg-pink-500" />
            </router-link>
          </div>
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <router-link to="/resource">
              <card-stats statSubtitle="Learning Resources" :statTitle="resource_arr.sum_all" 
                statIconName="fa fa-share-alt" statIconColor="bg-emerald-500" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardStats from "@/components/Cards/CardStats.vue";
import api from './../../services/student_services';

export default {
  components: {
    CardStats,
  },
  data() {
    return {
      student_arr: [],
      subject_arr: [],
      teacher_arr: [],
      resource_arr: [],
    }
  },
  methods: {
    async student_status() {
      api.student_status().then(async (result) => {
        this.student_arr = result.data;
      });
    },
    async subject() {
      api.subject().then(async (result) => {
        this.subject_arr = result.data;

      });
    },
    async teacher() {
      api.teacher().then(async (result) => {
        this.teacher_arr = result.data;
      });
    },
    async resource() {
      api.resource().then(async (result) => {
        this.resource_arr = result.data;      
      });
    },
  }, created: async function () {
    await this.student_status(),
    await this.subject(),
    await this.teacher(),
    await this.resource()
  },
};
</script>
